module.exports = __webpack_public_path__ + "static/media/liveDrawBgTop.1ed48397.png";